export type CurrencyPrice = {
    amount: number;
    currency: string;
};

export function ccyPrice(price: number, ccy: string = 'USD'): CurrencyPrice {
    return {
        amount: price,
        currency: ccy ?? 'USD'
    }
}

export function formattedPrice(price: number) {
    const text = price.toFixed(2);
    const parts = text.split('.');
    const whole = parts[0];
    const fraction = parts[1].padEnd(2, '0');
    return `${whole}.${fraction}`;
}
